import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _taggedTemplateLiteral from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { gql } from "@apollo/client";
import { isDateRangeIn, taxCalculation } from "./helper";
import { PURCHASABLE_BUFFER } from "@/lib/constants";
export var typeDef = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  type Product {\n    id: ID!\n    name: String!\n    thumbnailUrl: String\n    description: String\n    product_type: String\n    sales_start_at: String\n    sales_end_at: String\n    price: Int\n    priceWithoutTax: Int\n    rightIds: [Int]\n    purchased: Boolean\n    right: Right\n    meta: MediaMeta\n    purchaseAllowed: Boolean\n    voucherCode: VoucherCode\n    discountPrice: Int\n  }\n\n  type Query {\n    productById(id: Int): Product\n  }\n"])));
export var resolvers = {
  Query: {
    productById: function () {
      var _productById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_parent, args, _ref) {
        var dataSources, res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dataSources = _ref.dataSources;
                _context.next = 3;
                return dataSources.product.productById(args);

              case 3:
                res = _context.sent;
                return _context.abrupt("return", res);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function productById(_x, _x2, _x3) {
        return _productById.apply(this, arguments);
      }

      return productById;
    }()
  },
  Product: {
    id: function id(product) {
      return product.id || product.product_id;
    },
    thumbnailUrl: function thumbnailUrl(product, _args, _ref2) {
      var req = _ref2.req;
      var noimage = req.adultMode ? "/images/noimage_ex.png" : "/images/noimage.png";
      return product.thumbnail_url || noimage;
    },
    price: function price(product) {
      var _product$active_prici;

      return product === null || product === void 0 ? void 0 : (_product$active_prici = product.active_pricing) === null || _product$active_prici === void 0 ? void 0 : _product$active_prici.payment_amount;
    },
    priceWithoutTax: function priceWithoutTax(product) {
      var _product$active_prici2;

      return product === null || product === void 0 ? void 0 : (_product$active_prici2 = product.active_pricing) === null || _product$active_prici2 === void 0 ? void 0 : _product$active_prici2.price;
    },
    rightIds: function rightIds(product) {
      return product === null || product === void 0 ? void 0 : product.right_ids;
    },
    purchased: function () {
      var _purchased = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(product, _args, _ref3) {
        var req, dataSources, right, rightId, _yield$dataSources$us, entitlements;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                req = _ref3.req, dataSources = _ref3.dataSources;

                if (req.userToken) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return", false);

              case 3:
                if (product.ref_id) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return", false);

              case 5:
                _context2.next = 7;
                return dataSources.right.rightsByRefId(product.ref_id);

              case 7:
                right = _context2.sent;
                rightId = right.right_id;
                _context2.next = 11;
                return dataSources.user.entitlementsFromRight([rightId]);

              case 11:
                _yield$dataSources$us = _context2.sent;
                entitlements = _yield$dataSources$us.entitlements;
                return _context2.abrupt("return", entitlements && entitlements.length > 0 ? true : false);

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function purchased(_x4, _x5, _x6) {
        return _purchased.apply(this, arguments);
      }

      return purchased;
    }(),
    right: function () {
      var _right = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(product, _args, _ref4) {
        var dataSources, right;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                dataSources = _ref4.dataSources;
                _context3.next = 3;
                return dataSources.right.rightsByRefId(product.ref_id);

              case 3:
                right = _context3.sent;
                return _context3.abrupt("return", right);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function right(_x7, _x8, _x9) {
        return _right.apply(this, arguments);
      }

      return right;
    }(),
    meta: function () {
      var _meta = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(product, _args, _ref5) {
        var dataSources, right, _res$metas, res;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                dataSources = _ref5.dataSources;
                _context4.next = 3;
                return dataSources.right.rightsByRefId(product.ref_id);

              case 3:
                right = _context4.sent;

                if (!right) {
                  _context4.next = 11;
                  break;
                }

                _context4.next = 7;
                return dataSources.meta.searchFromRightId(right.right_id);

              case 7:
                res = _context4.sent;
                return _context4.abrupt("return", res === null || res === void 0 ? void 0 : (_res$metas = res.metas) === null || _res$metas === void 0 ? void 0 : _res$metas[0]);

              case 11:
                return _context4.abrupt("return", null);

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function meta(_x10, _x11, _x12) {
        return _meta.apply(this, arguments);
      }

      return meta;
    }(),
    purchaseAllowed: function purchaseAllowed(product) {
      return isDateRangeIn(product === null || product === void 0 ? void 0 : product.sales_start_at, product === null || product === void 0 ? void 0 : product.sales_end_at, {
        buffer: PURCHASABLE_BUFFER,
        default: true
      });
    },
    voucherCode: function voucherCode(product) {
      return product === null || product === void 0 ? void 0 : product.voucher_code;
    },
    discountPrice: function discountPrice(product) {
      if (product !== null && product !== void 0 && product.voucher_code) {
        var discount = product.voucher_code.voucher.discount_price;
        var price = product.active_pricing.price;
        return taxCalculation(price - discount);
      }

      return null;
    }
  }
};